import type { DataRequestFieldResponse } from "../models/data-request.model";

export function toFieldResponseMap(
  fieldResponses: DataRequestFieldResponse[] | undefined,
): Record<string, DataRequestFieldResponse> {
  const map: Record<string, DataRequestFieldResponse> = {};
  for (const response of fieldResponses ?? []) {
    map[response.fieldKey] = response;
  }
  return map;
}
